export const EMBEDDING_CONTAINER_CLASS_NAME = 'uc-embed';
export const EMBEDDING_OPTIONS_ATTRIBUTE_NAME = 'uc-data';
export const EMBEDDING_SERVICE_ATTRIBUTE_NAME = 'uc-consent-name';
export const EMBEDDING_SHOW_ALL_OPTIONS = 'all';
export const EMBEDDING_SHOW_ALL_SERVICES = 'all';
export const MAX_LIST_SIZE_IN_SUBLIST = 5;
